// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202511120804/js/" + chunkId + "." + {"44":"ca29505b","225":"e915104d","481":"5e2d535b","486":"d161b178","770":"76ba5775"}[chunkId] + ".0.939713419143952.chunk.js";
};